import { render } from "./DownloadDocuments.vue?vue&type=template&id=ad817760"
import script from "./DownloadDocuments.vue?vue&type=script&lang=js"
export * from "./DownloadDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__